import { Alert, Box, Stack, TextField } from "@mui/material";
import { useFormikContext } from "formik";
import type { RuntimeConfig } from "../pages/ConfigPage";
export const rtspServerDefaults = { listenAddress: "0.0.0.0:8554", advertisedHost: "", udpMin: 10000, udpMax: 10999, maxSessions: 64, maxSessionsPerTarget: 16 };
export default function RTSPServerForm() {
  const { values, setFieldValue } = useFormikContext<RuntimeConfig>();
  const settings = { ...rtspServerDefaults, ...values.rtspServer };
  return <Stack spacing={2}>
    <Alert severity="info">The server starts when you start a stream with an RTSP target. Changing these settings disconnects current RTSP clients; local playback continues.</Alert>
    {([ ["listenAddress", "Listen address"], ["advertisedHost", "Advertised hostname (optional)"] ] as const).map(([key, label]) => (
      <TextField key={key} label={label} value={settings[key]} onChange={e => setFieldValue(`rtspServer.${key}`, e.target.value)} />
    ))}
    <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", sm: "repeat(2, minmax(0, 1fr))" }, gap: 2 }}>
      {([ ["udpMin", "First UDP port (even)"], ["udpMax", "Last UDP port"], ["maxSessions", "Maximum sessions"], ["maxSessionsPerTarget", "Maximum sessions per target"] ] as const).map(([key, label]) => (
        <TextField key={key} fullWidth label={label} value={settings[key]} type="number" onChange={e => setFieldValue(`rtspServer.${key}`, Number(e.target.value))} />
      ))}
    </Box>
  </Stack>;
}
